import * as allColors from './colors';

export { default as createLivlyTheme } from './theme';
export { default as Icon } from './Icon';

export const colors = { ...allColors };
